import { useTranslation } from 'react-i18next';
import { Icon, ICON_NAMES, PdfPreview } from '@reverse-hr/design-system';
import type { FC } from 'react';
import type { TCurriculumPreviewProps } from '@components/Curriculum/Curriculum.types';

export const CurriculumPreview: FC<TCurriculumPreviewProps> = props => {
  const { curriculumUrl, onClick } = props;

  const { t } = useTranslation('', {
    keyPrefix: 'candidateDetails.dossier',
  });

  const showCurriculumLabel = t('showCurriculumButton');

  return (
    <button
      aria-label={showCurriculumLabel}
      className="app-c-curriculum__file"
      onClick={onClick}
      type="button"
    >
      <PdfPreview
        className="app-c-curriculum__file-preview"
        file={curriculumUrl}
      />

      <span className="app-c-curriculum__file-cta">
        <Icon name={ICON_NAMES.SHOW} />
        {showCurriculumLabel}
      </span>
    </button>
  );
};
